import * as React from 'react';
import {useFormContext} from 'react-hook-form';
import { Controller } from "react-hook-form"

import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {Select as MuiSelect} from '@mui/material';

const generateRandomHex = (length) => {
    const randomNumber = Math.random().toString(16);
    return randomNumber.substr(2, length);
}

const FormDropDown = ({name,label,list,required,rules = {},menuItemProps = {},fullWidth,...props}) => {

    const {control, formState } = useFormContext();

    const errors = formState.errors;
    const hasError = (name in errors) ? true : false;
    const errorMessage = (name in errors) ? errors[name]?.message : '';

    const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
    rules = { ...requiredDefaultRule, ...rules };

    fullWidth = (fullWidth === undefined) ? true : fullWidth;

    const id = generateRandomHex(8);
    const labelId = id + "-label";

    return (
        <Controller
            render={({field: {onChange, value, onBlur}}) =>(

      <FormControl fullWidth={fullWidth} error={(hasError) ? true : false}>
        <InputLabel id={labelId} required={required}>{label}</InputLabel>
        <MuiSelect
            onBlur={onBlur}
            labelId={labelId}
            label={label}
            required={required}
            value={value}
            onChange={onChange}
            {...props}
        >
          {list.map((cur)=>(<MenuItem key={cur.value || cur.label} value={cur.value || cur.label} {...menuItemProps}>{cur.label}</MenuItem>))}
        </MuiSelect>
        {hasError && <FormHelperText>{String(errorMessage)}</FormHelperText>}
      </FormControl>

            )}
            name={name}
            control={control}
            rules={rules}
        />
    );
};
export default FormDropDown;
